(function (global) {
  'use strict';

  function assertClient(client) {
    if (!client || typeof client.from !== 'function') {
      throw new Error('FanScoreGameplayAnalytics requires an initialized Supabase client.');
    }
  }

  function throwIfError(response) {
    if (response.error) {
      throw new Error(response.error.message || 'Gameplay analytics query failed.');
    }
    return response.data || [];
  }

  function FanScoreGameplayAnalytics(options) {
    options = options || {};
    assertClient(options.client);
    this.client = options.client;
  }

  FanScoreGameplayAnalytics.prototype.getTotals = async function (options) {
    options = options || {};
    var table = options.schoolId
      ? 'fs_gameplay_analytics_school_totals'
      : 'fs_gameplay_analytics_totals';

    var query = this.client
      .from(table)
      .select('*');

    if (options.schoolId) {
      query = query.eq('school_id', options.schoolId);
    }

    if (options.gameHandle) {
      query = query.eq('game_handle', options.gameHandle);
    }

    query = query.order('plays', { ascending: false });

    return throwIfError(await query);
  };

  FanScoreGameplayAnalytics.prototype.getDaily = async function (options) {
    options = options || {};

    var query = this.client
      .from('fs_gameplay_analytics_daily')
      .select('*');

    if (options.schoolId) {
      query = query.eq('school_id', options.schoolId);
    }

    if (options.gameHandle) {
      query = query.eq('game_handle', options.gameHandle);
    }

    if (options.from) {
      query = query.gte('play_date', options.from);
    }

    if (options.to) {
      query = query.lte('play_date', options.to);
    }

    query = query
      .order('play_date', { ascending: true })
      .order('game_name', { ascending: true });

    return throwIfError(await query);
  };

  FanScoreGameplayAnalytics.prototype.getSessions = async function (options) {
    options = options || {};
    var limit = Math.min(Math.max(Number(options.limit || 250), 1), 1000);

    var query = this.client
      .from('fs_gameplay_analytics_sessions')
      .select('*');

    if (options.schoolId) {
      query = query.eq('school_id', options.schoolId);
    }

    if (options.gameHandle) {
      query = query.eq('game_handle', options.gameHandle);
    }

    if (options.status) {
      query = query.eq('status', options.status);
    }

    if (options.from) {
      query = query.gte('started_at', options.from);
    }

    if (options.to) {
      query = query.lte('started_at', options.to);
    }

    query = query
      .order('started_at', { ascending: false })
      .limit(limit);

    return throwIfError(await query);
  };

  FanScoreGameplayAnalytics.prototype.getIntegrationStatus = async function () {
    var query = this.client
      .from('fs_gameplay_integration_status')
      .select('*')
      .order('analytics_status', { ascending: true })
      .order('game_name', { ascending: true });

    return throwIfError(await query);
  };

  global.FanScoreGameplayAnalytics = FanScoreGameplayAnalytics;
})(window);
